import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createConfig, deleteConfig, getConfig, getConfigs, updateConfig, patchConfig,
  batchUpdateConfigs, batchPatchConfigs,
} from '../api/configs';

export const useUpdateConfig = () => useMutation({ mutationFn: (data: any) => updateConfig(data.id, data) });

export const useUpdateConfigId = (configId: string) =>
  useMutation({ mutationFn: (data: any) => updateConfig(configId, data) });

/** Partial update — sends only the keys given. See `patchConfig`. */
export const usePatchConfigId = (configId: string) =>
  useMutation({ mutationFn: (data: any) => patchConfig(configId, data) });

export const useBatchPatchConfigs = () => useMutation({ mutationFn: (configs: any[]) => batchPatchConfigs(configs) });

export const useCreateConfig = () => useMutation({ mutationFn: (data: any) => createConfig(data) });

export const useDeleteConfig = () => useMutation({ mutationFn: (configId: string) => deleteConfig(configId) });

export const useBatchUpdateConfigs = () => useMutation({ mutationFn: (configs: any[]) => batchUpdateConfigs(configs) });

/* Calibrations and Configs are now the same thing, this is leftover */
export const useConfigsId = (configIds?: string[]) =>
  useQuery({
    queryKey: ['configs', configIds],
    queryFn: () => getConfigs(configIds),
  });

export const useConfigWithGates = (configId: string, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['config-gates', configId],
    queryFn: () => getConfig(configId, 'gates').then((data) => data),
    enabled: options?.enabled !== false && !!configId,
  });

export const useSetConfig = () => {
  const queryClient = useQueryClient();
  return (data: any) => {
    queryClient.setQueryData(['config', data.id], data);
  };
};
